import { SapienInertia } from "@/inertia-utils/hooks";

export function closeModal(newURL:string){
    SapienInertia.visit(newURL, {
        only: ["locationInfo"],
        preserveState: true,
        preserveScroll: true,
    })
}
